import { Prop, Component, Vue } from 'vue-property-decorator';
import authenticator from '@/store/authentication';
import { UserProfile } from '@/types';

@Component
export default class UserAvatar extends Vue {

    @Prop({ default: '' }) private readonly avatar!: string;

    private get user(): UserProfile {
        if (authenticator.isLoggedIn) {
            return authenticator.userProfile;
        } else {
            return {
                name: 'Utente',
                given_name : 'Utente',
                family_name: '',
            } as UserProfile;
        }
    }

    private get avatarUrl(): string {
        if (authenticator.isLoggedIn) {
            const initials = `${this.user.given_name.charAt(0)}${this.user.family_name.charAt(0)}`;
            return `https://avatars.dicebear.com/v2/initials/${initials}.svg`;
        } else {
            return 'https://avatars.dicebear.com/v2/bottts/5.svg';
        }
    }
}